import { Stack, Typography } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import React from "react";
import { globalTheme } from "../../../../styles";

/**
 * This is Date Time Renderer Component
 * This renders the date and time to the readable form
 * Format: dd/mm/yyyy , hh/mm/ss Am/PM
 */

interface DateTimeCellProps extends CustomCellRendererProps {
  value: string;
}

// Memoize cell level component to avoid unnecessary re-renders. This helps enhance performance improvements.
export const DateTimeCell = React.memo(({ value }: DateTimeCellProps) => {
  const formattedValue = React.useMemo(() => {
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${period}`;
  }, [value]);

  return (
    <Stack sx={{ margin: 3 }}>
      <Typography variant="body2" color={globalTheme.primaryColor}>
        {formattedValue}
      </Typography>
    </Stack>
  );
});
